import React from "react";
import { Tooltip } from "react-tooltip";
import { TbMinusVertical } from "react-icons/tb";

function formatDate(dateString) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(dateString);

  const monthName = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  const formattedDate = `${monthName} ${day}, ${year}`;
  return formattedDate;
}

const Bar = ({
  date,
  index,
  component,
  color,
  content,
  incident,
  downtime,
  majorHours,
  majorMinutes,
  partialHours,
  partialMinutes,
}) => {
  const formattedDate = formatDate(date);

  const downtimeContent = content
    .split(",")
    .map((item) => {
      let downtime = "";
      item = item.trim();
      if (item === "Major outage") {
        if (majorHours < 24) {
          downtime = `${majorHours || "00"}hrs ${majorMinutes || "00"}min`;
        } else {
          downtime = "24:00 hrs";
        }
      } else if (item === "Partial outage") {
        if (partialHours < 24) {
          downtime = `${partialHours || "00"}hrs ${partialMinutes || "00"}min`;
        } else {
          downtime = "24:00 hrs";
        }
      }

      if (
        item === "No downtime recorded on this day." ||
        item === "No data exists for this day."
      ) {
        return `<h2>${item}</h2><br />`;
      } else {
        return `<h2>${item} - ${downtime}</h2><br />`;
      }
    })
    .join("");

  return (
    <div>
      <a
        data-tooltip-id={`my-tooltip-${component + index}`}
        data-tooltip-html={
          "<p><strong>" +
          formattedDate +
          "</strong></p><br />" +
          downtimeContent +
          (incident
            ? "<h2><strong>RELATED</strong></h2>" +
              incident
                .split(",")
                .map((name) => "<h2>" + name + "</h2><br />")
                .join("")
            : "")
        }
      >
        <svg
          stroke="currentColor"
          fill="none"
          stroke-width="2"
          viewBox="12 0.5 0.5 23"
          stroke-linecap="round"
          stroke-linejoin="round"
          color={color}
          height="40"
          width="8"
          xmlns="http://www.w3.org/2000/svg"
          style={{ color: color }}
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M12 5v14"></path>
        </svg>
      </a>
      <Tooltip className="my-tooltip" id={`my-tooltip-${component + index}`} />
    </div>
  );
};

export default Bar;
